// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import PhoneFormatController from "./phone_format_controller"
application.register("phone-format", PhoneFormatController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import SubmitOnceController from "./submit_once_controller"
application.register("submit-once", SubmitOnceController)

import SubscriptionPollController from "./subscription_poll_controller"
application.register("subscription-poll", SubscriptionPollController)

import ThreadScrollController from "./thread_scroll_controller"
application.register("thread-scroll", ThreadScrollController)

import MobileRowController from "./mobile_row_controller"
application.register("mobile-row", MobileRowController)
